import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Button, Stack } from '@mui/material'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const UpdatePartyRatesModal = (props) => {
  const { dataValues, updateModal } = props
  const {saveApi, filters,setIsSuccess, isSuccess} = dataValues
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback

  useEffect(()=>{
    focusElemnt('noBtn')
  },[])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <>
      <Modal
        headTxt={tr('updatePartyRates', 'Update Party Rates')}
        width={'446px'}
        updateModal={updateModal}
        closeId={"closeButton"}
        modalClass={'booking-popup'}
        modalStyle={modalStyle}
      >
        <Stack style={{ display: 'flex', flexDirection: 'column', padding: '16px 16px' }}>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444', paddingBottom: '16px' }}>
            {tr('clickYesSaveUpdatedPartyRates', 'Please click "YES" to Save the Updated Party Rates of :')}
          </div>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
            <span style={{ display: 'inline-block', width: '30%' }}>{tr('party', 'Party')}</span><span style={{ display: 'inline-block', width: '10%' }}>:</span><span style={{ display: 'inline-block', width: '60%' }}>{filters?.partyName?.Party}</span>
          </div>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
            <span style={{display: 'inline-block', width: '30%' }}>{tr('serviceType', 'Service Type')}</span><span style={{display: 'inline-block', width: '10%' }}>:</span><span style={{display: 'inline-block', width: '60%' }}>{tr(filters?.serviceType?.translationKey, filters?.serviceType?.name)}</span>
          </div>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
            <span style={{display: 'inline-block', width: '30%' }}>{tr('consignmentType', 'Consignment Type')} </span><span style={{display: 'inline-block', width: '10%' }}>:</span><span style={{display: 'inline-block', width: '60%' }}>{tr(filters?.consignmentType?.translationKey, filters?.consignmentType?.name)}</span>
          </div>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
            <span style={{display: 'inline-block', width: '30%' }}>{tr('billingUnit', 'Billing Unit')} </span><span style={{display: 'inline-block', width: '10%' }}>:</span><span style={{display: 'inline-block', width: '60%' }}>{tr(filters?.billingUnit?.translationKey, filters?.billingUnit?.name)}</span>
          </div>
          <div style={{ fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
            <span style={{display: 'inline-block', width: '30%' }}>{tr('gsStatus', 'Status')}</span><span style={{display: 'inline-block', width: '10%' }}>:</span><span style={{display: 'inline-block', width: '60%' }}>{tr(filters?.status?.translationKey, filters?.status?.name)}</span>
          </div>
          </Stack>
          <Stack className='itemButtons' style={{ width: '100%', display: 'flex', flexDirection:'row', justifyContent: 'flex-end', borderTop:'1px solid rgba(221, 221, 221, 1)', padding:'12px' }}>
            <Button
              variant="outlined"
              id={'noBtn'}
              sx={{  }}
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'yesBtn', 'yesBtn', ()=>{ updateModal()})
            }
              onClick={() => {
                updateModal()
              }}
            >
            {tr('gsNo', 'No')}
            </Button>
            <Button
              id="yesBtn"
              style={{ margin: '0px 0px 0px 5px', height: "40px" }}
              className="btn add-btn"
              variant="contained"
              color="error"
            onClick={() => saveApi()}
            onKeyDown={(e) => navigation3(e, 'noBtn', 'noBtn', ()=>{})
            }
            >
              {tr('gsYes', 'Yes')}
            </Button>
          </Stack>

      </Modal>

    </>
  )
}

export default UpdatePartyRatesModal
